import { lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AdminShell } from './components/AdminShell';
import { RequirePermission } from './components/RequirePermission';

const OverviewScreen = lazy(() => import('./screens/Overview'));
const WorkScreen = lazy(() => import('./screens/Work'));
const InsightsScreen = lazy(() => import('./screens/Insights'));
const OrgsScreen = lazy(() => import('./screens/Orgs'));
const OrgDetailScreen = lazy(() => import('./screens/OrgDetail'));
const UsersScreen = lazy(() => import('./screens/Users'));
const BillingScreen = lazy(() => import('./screens/Billing'));
const AuditScreen = lazy(() => import('./screens/Audit'));
const OperationsScreen = lazy(() => import('./screens/Operations'));
const PlatformScreen = lazy(() => import('./screens/Platform'));
const AdministrationScreen = lazy(() => import('./screens/Administration'));

export function AppRoutes() {
  return (
    <Routes>
      <Route element={<AdminShell />}>
        <Route index element={<OverviewScreen />} />
        <Route path="work" element={<WorkScreen />} />
        <Route path="insights" element={<RequirePermission permission="backoffice.analytics.read"><InsightsScreen /></RequirePermission>} />
        <Route path="orgs" element={<RequirePermission permission="backoffice.organizations.read"><OrgsScreen /></RequirePermission>} />
        <Route path="orgs/:orgId" element={<RequirePermission permission="backoffice.organizations.read"><OrgDetailScreen /></RequirePermission>} />
        <Route path="orgs/:orgId/:tab" element={<RequirePermission permission="backoffice.organizations.read"><OrgDetailScreen /></RequirePermission>} />
        <Route path="users" element={<RequirePermission permission="backoffice.users.read"><UsersScreen /></RequirePermission>} />
        <Route path="users/:userId" element={<RequirePermission permission="backoffice.users.read"><UsersScreen /></RequirePermission>} />
        <Route path="billing" element={<RequirePermission permission="backoffice.billing.read"><BillingScreen /></RequirePermission>} />
        <Route path="announcements" element={<Navigate to="/platform" replace />} />
        <Route path="audit" element={<RequirePermission permission="backoffice.audit.read"><AuditScreen /></RequirePermission>} />
        <Route path="audit/:recordId" element={<RequirePermission permission="backoffice.audit.read"><AuditScreen /></RequirePermission>} />
        <Route path="integrations" element={<Navigate to="/operations?tab=integrations" replace />} />
        <Route path="imports" element={<Navigate to="/operations?tab=imports" replace />} />
        <Route path="notifications" element={<Navigate to="/operations?tab=notifications" replace />} />
        <Route path="files" element={<Navigate to="/operations?tab=files" replace />} />
        <Route path="operations" element={<RequirePermission permission="backoffice.operations.read"><OperationsScreen /></RequirePermission>} />
        <Route path="platform" element={<RequirePermission permission="backoffice.announcements.read"><PlatformScreen /></RequirePermission>} />
        <Route path="administration" element={<RequirePermission permission="backoffice.team.read"><AdministrationScreen /></RequirePermission>} />
        <Route path="team" element={<Navigate to="/administration?tab=team" replace />} />
        <Route path="settings" element={<Navigate to="/administration?tab=account" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
